import GlobalNav from './global-nav'

export { GlobalNav as default }
